import React from "react";
import { useCart } from "../../hooks";
import { truncateShopifyId } from "../../utilities/truncateShopifyId";

export default function AddToCart({
  product,
  variant,
  quantity,
  classNames,
  disabled,
  recharge,
  buttonText,
  bundleItems = [],
  mountItems = [],
}) {
  const { openCartWithTimer, addVariantToCart, addBundleToCart } = useCart();

  const callback = () => {
    openCartWithTimer(5000);
  };
  const handleClick = () => {
    if (bundleItems.length || mountItems.length) {
      addBundleToCart(
        variant.storefrontId,
        quantity,
        recharge,
        bundleItems,
        mountItems,
        callback
      );
    } else if (variant) {
      addVariantToCart(variant.storefrontId, quantity, recharge, callback);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "addToCart",
        ecommerce: {
          currencyCode: product.priceRangeV2.minVariantPrice.currencyCode,
          add: {
            products: [
              {
                name: product.title,
                id: truncateShopifyId(variant.shopifyId),
                price: variant.price,
                brand: "Thermacell",
                variant: variant.title,
                quantity: quantity,
                category: "",
              },
            ],
          },
        },
      });
    }
  };

  return (
    <button
      className={classNames}
      type="button"
      onClick={handleClick}
      disabled={disabled}
    >
      {disabled ? "Sold Out" : buttonText ? buttonText : "Add to cart"}
    </button>
  );
}
